package com.dotdrives.web.pages.nextsteps

import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.input
import react.dom.html.ReactHTML.span
import web.cssom.ClassName
import web.html.ButtonType
import web.html.InputType
import web.html.button as buttonType
import kotlin.time.Instant

external interface SnoozePopoverProps : Props {
    var now: Instant
    var onPick: (Instant) -> Unit
    var onClose: () -> Unit
    var alignLeft: Boolean?
    /** An extra trailing row (label to callback) -- used by the compact "···" row menu to
     * fold "Reassign" into the same popover instead of stacking two floating panels. */
    var extraItem: Pair<String, () -> Unit>?
}

/** "⏰ Later today · 4 PM" / "🌅 Tomorrow morning" / "📅 Next Monday" / "🗓 Pick a date…"
 * (`portal-next-steps.dc.html`, Snooze Popover). */
val SnoozePopover = FC<SnoozePopoverProps> { props ->
    div {
        className = ClassName("ns-popover" + if (props.alignLeft == true) " ns-popover-left" else "")

        SnoozeOption("⏰ Later today · 4 PM") { props.onPick(snoozeLaterToday(props.now)) }
        SnoozeOption("🌅 Tomorrow morning") { props.onPick(snoozeTomorrowMorning(props.now)) }
        SnoozeOption("📅 Next Monday") { props.onPick(snoozeNextMonday(props.now)) }

        div {
            className = ClassName("ns-popover-item")
            span { +"🗓 Pick a date…" }
            input {
                // "date" is not one of web.html.InputType's typed members in this wrapper
                // version -- the same unsafeCast-string pattern already used for AriaRole
                // elsewhere in this codebase (e.g. MoveConfirmDialog.kt's "presentation").
                type = "date".unsafeCast<InputType>()
                ariaLabel = "Pick a snooze date"
                className = ClassName("ns-subject-search")
                onChange = { event ->
                    val value = event.currentTarget.value
                    if (value.isNotBlank()) {
                        Instant.parse("${value}T09:00:00Z").let(props.onPick)
                    }
                }
            }
        }

        props.extraItem?.let { (label, onClick) ->
            SnoozeOption(label, onClick)
        }
    }
}

private fun react.ChildrenBuilder.SnoozeOption(label: String, onClick: () -> Unit) {
    react.dom.html.ReactHTML.button {
        type = ButtonType.buttonType
        className = ClassName("ns-popover-item")
        this.onClick = { onClick() }
        +label
    }
}
